module.exports = __webpack_public_path__ + "img/2.d6a84cb0.jpg";